var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.boardData.length === 0)?_c('board-empty-link',{attrs:{"emptyLayout":_vm.emptyLayout}}):_c('board-list-link',{attrs:{"boardData":_vm.boardData,"listLayout":_vm.listLayout}})
}
var staticRenderFns = []

export { render, staticRenderFns }